export const FundingRateScope = {
  AssetLevel: 'asset-level',
  ByExchange: 'exchange-asset',
} as const;
export type FundingRateScope = (typeof FundingRateScope)[keyof typeof FundingRateScope];

export const FUNDING_RATE_TIME_RANGES = ['1D', '1W', '1M', '3M', '1Y', 'All'] as const;
export type FundingRateTimeRange = (typeof FUNDING_RATE_TIME_RANGES)[number];

export const FUNDING_RATE_MA_WINDOWS = [0, 7, 14, 30] as const;
export type FundingRateMAWindow = (typeof FUNDING_RATE_MA_WINDOWS)[number];

export const FUNDING_RATE_FREQUENCIES = ['1h', '1d'] as const;
export type FundingRateFrequency = (typeof FUNDING_RATE_FREQUENCIES)[number];
